import { render, staticRenderFns } from "./OfficialCollect.vue?vue&type=template&id=87bcccf4&scoped=true"
import script from "./OfficialCollect.vue?vue&type=script&lang=js"
export * from "./OfficialCollect.vue?vue&type=script&lang=js"
import style0 from "./OfficialCollect.vue?vue&type=style&index=0&id=87bcccf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bcccf4",
  null
  
)

export default component.exports